if (!customElements.get("ships-by-notification")) {
  customElements.define(
    "ships-by-notification",

    class ShipsByNotification extends HTMLElement {
      constructor() {
        super();

        this.productId = this.dataset.id;
        this.variantId =
          this.dataset.variantId === "" ? null : this.dataset.variantId;
        this.sectionId = this.dataset.section;

        /**
         * @type {HTMLElement | null}
         * */
        this.notificationOutput = this.querySelector(
          `#${this.sectionId}-shipping-date`
        );

        window.addEventListener("message", (event) => {
          if (event.data.type === "update_ships_by_notification") {
            // console.trace('update_ships_by_notification: ', event.data);
            this.updateShippingNotification(event.data);
          }
        });
      }

      connectedCallback() {
        const message = {
          type: "ships_by_notification_ready",
          productId: this.productId,
          variantId: this.variantId,
        };
        // console.log("sending message: ", message);

        window.postMessage(message, "*");
      }

      /**
       *
       * @param {string} data
       */
      updateShippingNotification(data) {
        if (data.productId === this.productId && this.notificationOutput) {
          // console.log("updateShippingNotification: ", data);
          this.notificationOutput.innerText = data.shippingDate;
        }
      }
    }
  );
}
